import { Stack } from "@mui/material";
import { message } from "antd";
import { Timestamp } from "firebase/firestore";
import { FormButton } from "../components/buttons/FormButton";
import { GenericSwitch } from "../components/elements/Switch";
import { ImageWrapper } from "../components/image/ImageViewer";
import { GenericInput } from "../components/input/GenericInput";
import { GenericSelect } from "../components/select/GenericSelect";
import { FormWrapper } from "../components/styled/StyledComponents";
import { FEED_API } from "../constants/api";
import {
  sActive,
  sAddSection,
  sBanners,
  SORT,
  sUpdate,
} from "../constants/strings";
import {
  BANNER_VIEW,
  CATEGORY_VIEW,
  PRODUCT_SECTION,
} from "../constants/webapp";
import { useAppContext } from "../context/useAppContext";
import { useFirebase } from "../hooks/firebase/useFirebase";
import useForm from "../hooks/useForm";
import { useUpload } from "../hooks/useUpload";
import { timestamp } from "../utils/FirebaseHelper";
import { AutofillForm } from "../utils/helpers";
import { ExpandableBannerForm } from "./ExpandableBannerForm";

export const displayTypes = [
  {
    id: 1,
    name: "Vertical List",
  },
  {
    id: 2,
    name: "Grid View",
  },
];

export const feedTypes = [
  {
    id: PRODUCT_SECTION,
    name: "Product Section",
  },
  {
    id: BANNER_VIEW,
    name: "Banner View",
  },
  {
    id: CATEGORY_VIEW,
    name: "Category View",
  },
];

export const FeedForm = ({ data, setOpen }) => {
  const { loading, addData: addFeedSection, updateData } = useFirebase();
  const {
    imageUrls: uploadedUrls,
    uploadImages,
    loading: uploading,
  } = useUpload();
  const { form, onChange, updateFormValue, updateFormValues, setForm } =
    useForm({
      active: true,
      timestamp,
      sort: 0,
      type: 1,
      display_type: 1,
    });

  const { contextData } = useAppContext();
  const { categories, topMenu } = contextData;
  // const [images, setImages] = useState([]);
  var cleanUpFields = {};

  AutofillForm(data, setForm);

  // update feed
  function updateFeed() {
    switch (form.type) {
      case PRODUCT_SECTION:
        break;
      case CATEGORY_VIEW:
        delete form.display_type;
        delete form.subtitle;
        break;
      default:
        break;
    }
    updateData(data.docRef, form).then(() => setOpen(false));
  }

  function setBannerData() {
    delete form.display_type;

    // attach uploaded urls to banner items
    const banners = form?.banners;

    const newBanners = banners?.map((val, i) => {
      const newItem = { ...val };
      delete newItem.images;
      newItem.url = uploadedUrls[i];
      return newItem;
    });

    form.banners = newBanners;

    addGenericSection();
  }

  function addBannerView() {
    const banners = form?.banners;
    // get all images from the banner list
    const images = banners
      ?.filter((a) => a.images)
      ?.map((val) => val.images?.[0]);

    if (images?.length !== banners?.length || images == null) {
      message.error("Select one image for each banner item");
    } else {
      uploadImages(images, sBanners, setBannerData);
    }
  }

  // function addCategoryView() {
  //   if (images.length === 0) {
  //     message.error("Select atleast one image");
  //   } else {
  //     uploadImages(images, sBanners, setBannerData);
  //   }
  // }

  function cleanUp() {
    switch (form.type) {
      case PRODUCT_SECTION:
        cleanUpFields = {
          title: "",
          subtitle: "",
          sort: 0,
          category: [],
          images: [],
        };
        // setImages([]);
        break;
      case CATEGORY_VIEW:
        cleanUpFields = {
          title: "",
          sort: 0,
          category: [],
        };
        break;
      case BANNER_VIEW:
        cleanUpFields = {
          title: "",
          sort: 0,
          banners: [{}],
        };
        break;

      default:
        break;
    }
    updateFormValues(cleanUpFields);
  }

  function addGenericSection() {
    addFeedSection(FEED_API, form, cleanUp());
  }

  function handleAddFeed() {
    form.timestamp = Timestamp.now();

    switch (form.type) {
      case PRODUCT_SECTION:
      case CATEGORY_VIEW:
        addGenericSection();
        break;
      case BANNER_VIEW:
        addBannerView();
        break;

      default:
        break;
    }
  }

  const onSubmit = (e) => {
    e.preventDefault();

    if (data) {
      updateFeed();
    } else {
      handleAddFeed();
    }
  };

  // console.log(form);

  return (
    <form onSubmit={onSubmit}>
      <FormWrapper>
        <Stack spacing={3}>
          {/* Feed Type */}
          <GenericSelect
            disabled={data && true}
            label="Feed Section Type"
            value={form.type}
            options={feedTypes?.map((item) => {
              return {
                value: item.id,
                label: item.name,
              };
            })}
            onChange={(value) => {
              updateFormValues({ type: value });
            }}
            required
          />

          {/* Title */}
          <GenericInput
            label="Title"
            required
            value={form.title}
            name="title"
            onChange={onChange}
          />

          {form.type === PRODUCT_SECTION ? (
            // Product View
            <>
              {/* Sub-Title */}
              <GenericInput
                label="Subtitle"
                value={form.subtitle}
                name="subtitle"
                onChange={onChange}
              />

              {/* Categories */}
              <GenericSelect
                label="Category"
                mode="multiple"
                value={form.category}
                options={categories?.map((item) => {
                  return {
                    value: item.id,
                    label: item.category_name,
                  };
                })}
                onChange={(value) => {
                  updateFormValues({ category: value });
                }}
                helperText="You can select multiple categories to display."
                required
              />

              {/* Display Type */}
              <GenericSelect
                label="Display Type"
                value={form.display_type}
                options={displayTypes?.map((item) => {
                  return {
                    value: item.id,
                    label: item.name,
                  };
                })}
                onChange={(value) => {
                  updateFormValues({ display_type: value });
                }}
                info="How section will appear in the App e.g Grid format, List style etc."
                required
              />
            </>
          ) : form.type === BANNER_VIEW ? (
            // Banner View
            <>
              <ExpandableBannerForm
                field="banners"
                form={form}
                updateFormValues={updateFormValues}
              />
              {/* Images */}
              <ImageWrapper images={data?.imageUrls} />
              {/* Images */}
              {/* <FileUploader
                images={images}
                setImages={setImages}
                label="Section Images"
                required
                helperText="Minimum resolution 320 x 150 (16:9) recommended, upto 1MB."
              /> */}
            </>
          ) : (
            <>
              {/* Categories */}

              <GenericSelect
                label="Category"
                mode="multiple"
                value={form.category}
                options={[...categories, ...topMenu].map((item) => {
                  return {
                    value: item.id,
                    label: item.category_name,
                  };
                })}
                onChange={(value) => {
                  updateFormValues({ category: value });
                }}
                helperText="You can select multiple categories to display."
                required
              />
            </>
          )}

          {/* Sort */}
          <GenericInput
            label="Sort"
            value={form.sort}
            name={SORT}
            type="number"
            onChange={onChange}
            helperText="Display order of arrangement."
          />

          {/* Switch */}
          <GenericSwitch label={sActive} updateFormValue={updateFormValue} />

          {/* Submit */}
          <FormButton loading={uploading || loading}>
            {data ? sUpdate : sAddSection}
          </FormButton>
        </Stack>
      </FormWrapper>
    </form>
  );
};
